export enum WithdrawSource {
  Arctica = 'MolodayaArctica',
  Ekg = 'Ekg',
}

export interface MolodayaArcticaItem {
  score: number;
  date: string;
  withdrawSource: WithdrawSource;
  products: MolodayaArcticaProduct[];
}

export interface MolodayaArcticaProduct {
  id: number;
  title: string;
  count: number;
  image: string;
}
